import { patchUserPreferencesRequest } from '~/api/user';
import { UserPreferences } from '~/plugins/auth/_types';

export const updateUserPreferences = async (preferences: UserPreferences) => {
    return await patchUserPreferencesRequest(preferences);
};
